import { TransactionDetailContent } from './TransactionDetailContent';

export function PaymentTransactionDetailContent() {
    return <TransactionDetailContent mode="payment-transactions" />;
}
